import ColorfulInput from './colorful-input';
export default ColorfulInput;
